
const data = {
    "siteId": process.env.GATSBY_SITE_ID,
    "accessId": process.env.GATSBY_ACCESS_ID
  }
  
  const getNewsDetails = async () => {
      try {
        const response = await fetch(process.env.GATSBY_NEWS_URL, {
          method: "POST",
          headers: {
            "appid": process.env.GATSBY_NEWSAPP_ID,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });
         const result = await response.json();
         return result?.data || []
      } catch (error) {
        throw new Error(error)
      }
    }
  
    module.exports = { getNewsDetails }